import React from 'react';
import PrintBoxLabel from '../labels/PrintBoxLabel';
import './PrintLabelModal.css';

interface PrintLabelModalProps {
  isOpen: boolean;
  onClose: () => void;
  sku?: string;
  quantity?: number;
  shelfIndex?: string;
}

function PrintLabelModal({
  isOpen,
  onClose,
  sku,
  quantity,
  shelfIndex,
}: PrintLabelModalProps) {
  if (!isOpen) return null;

  return (
    <div className="plm-overlay">
      <button className="plm-close" onClick={onClose} aria-label="Close">×</button>

      <PrintBoxLabel
        embedded
        initialSku={sku}
        initialLabelType={sku ? 'stock' : undefined}
        initialBaseQty={quantity}
        initialShelfIndex={shelfIndex}
        source="receiving_modal"
      />
    </div>
  );
}

export default PrintLabelModal;
